import { PopupObjectiveAlreadyCompleteComponent } from './popup-objective-already-complete.component';

export const PopupObjectiveAlreadyCompleteModule = angular
  .module('sfMobile.components.popup-objective-already-complete', [])
  .component(
    'sfPopupObjectiveAlreadyComplete',
    PopupObjectiveAlreadyCompleteComponent
  ).name;
